import { useSelector } from "react-redux";
import intl from "../../services/intl";
import cartSelectors, {
  showProductOfferLimitBanner,
} from "../../store/cart/selectors";
import cartProductSelectors from "../../store/cart-product/selectors";
import { getBundleCartLimit } from "../../utils/bundle";
import CartBanner from "./CartBanner";
import useVariation from "../../hooks/useVariation";
import { amountPriceTotal, basePriceTotal } from "../../utils/cart";

export default function CartTopBannerArea({ className }) {
  const welcomeOfferPromotionFlag = useVariation("welcome-offer-promotion", {});
  const welcomeOfferPromotionEnabled =
    welcomeOfferPromotionFlag?.slug &&
    welcomeOfferPromotionFlag?.slug === "welcome-offer-alc";

  const activeCart = useSelector(cartSelectors.activeCart);
  const activeCartProducts = useSelector(
    cartProductSelectors.activeCartProducts,
  );
  let discountAmount =
    activeCart.discountAmount + activeCart.productOfferDiscountAmount;

  if (welcomeOfferPromotionEnabled) {
    const basePriceDiscount =
      basePriceTotal(activeCartProducts) - amountPriceTotal(activeCartProducts);
    discountAmount =
      (activeCart?.productOfferDiscountAmount || 0) + basePriceDiscount;
  }

  const shouldShowLimitBanner = useSelector(cartSelectors.showLimitBanner);

  const shouldShowWipeoutBanner = useSelector(cartSelectors.showWipeoutBanner);

  const quantityLimit = getBundleCartLimit();
  const shouldShowProductOfferLimitBanner = useSelector(
    showProductOfferLimitBanner,
  );

  return (
    <>
      {shouldShowLimitBanner && (
        <CartBanner
          className={`${className} neutral-banner`}
          bannerMessage={intl.t(
            "cart.review-order.banner-limit",
            "You've reached the maximum number of items in cart — remove some to add more.",
          )}
        />
      )}
      {shouldShowProductOfferLimitBanner && (
        <CartBanner
          className={`${className} neutral-banner`}
          bannerMessage={intl.t(
            "cart.review-order.banner-product-offer-limit",
            "You already have that product bundle in your cart.",
          )}
        />
      )}
      {shouldShowWipeoutBanner && (
        <CartBanner
          className={`${className} neutral-banner`}
          bannerMessage={intl.t(
            "cart.review-order.banner-wipeout",
            `You can only have {limit} items in your cart at a time—we’ve replaced your previous items with the new ones added.`,
            { limit: quantityLimit },
          )}
        />
      )}
      {discountAmount > 0 && (
        <CartBanner
          className={className}
          bannerMessage={intl.t(
            "cart.review-order.banner-discount",
            `You're saving {discountAmount} on your first order`,
            {
              discountAmount: intl.formatCurrency(
                Math.floor(discountAmount / 100).toFixed(0),
                { round: true },
              ),
            },
          )}
        />
      )}
    </>
  );
}
